import { Button, Form, Input, Radio, Space } from "antd";
import { ModalComponentProps } from "../../types";
import CustomModal from "../ui/CustomModal";

export default function AddNewRole({
  handleClose,
  data,
  type,
  ...rest
}: ModalComponentProps) {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {};

  return (
    <CustomModal
      //   title=""
      title="Add New Role"
      {...rest}
      handleClose={handleClose}
      width={600}
      footer={null}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <>
          <div>
            <Form.Item
              name=""
              label="User Role Name"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please enter a title",
                },
              ]}
            >
              <Input size="large" placeholder="Select title" />
            </Form.Item>

            <Form.Item
              name=""
              label="Role Type Name"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please enter description",
                },
              ]}
            >
              <Input size="large" placeholder="Short description" />
            </Form.Item>

            <div className="flex items-center gap-6">
              <p className="text-[#2d3643] text-base font-medium leading-7">
                System Type:
              </p>
              <Form.Item
                name="target_type"
                initialValue="all"
                className="mb-0 "
              >
                <Radio.Group
                  className="custom-radio !h-auto gap-6"
                  size="large"
                >
                  {targetTypes?.map((el) => (
                    <Radio
                      className="text-header text-sm font-medium mr-3.5"
                      value={el?.value}
                      key={el?.value}
                    >
                      {el.label}
                    </Radio>
                  ))}
                </Radio.Group>
              </Form.Item>
            </div>
          </div>

          <Space className="w-full mt-2" size={12}>
            <Button
              className="normal-dark-button modal-button"
              onClick={handleClose}
              size="middle"
            >
              Cancel
            </Button>
            <Button
              className="modal-button"
              type="primary"
              htmlType="submit"
              size="middle"
            >
              {type === "UPDATE" ? "Update" : "Save"}
            </Button>
          </Space>
        </>
      </Form>
    </CustomModal>
  );
}

export const targetTypes = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];
